import { BioSampleContainer, SiteNumberAndName } from '@csp/csp-common-hbs-model';
import { Site } from '@csp/csp-common-model';
import { OrgService, SiteMapper } from '@csp/csp-common-org';
import { isDefined } from '@csp/csp-common-util';
import { CriteriaType } from '@csp/dmdp-api-common-dto';
import { uniq } from 'lodash';

type ValidateKitSiteIn = {
  sites: Site[];
  containers: BioSampleContainer[];
};

const findMismatchingSites = async ({ sites, containers }: ValidateKitSiteIn): Promise<SiteNumberAndName[]> => {
  const siteNumbers = sites.map(site => site.siteNumber).filter(isDefined);
  const siteNumbersWithoutMatch =
    uniq(containers.map(container => container.siteNumber))
      .filter(isDefined)
      .filter(siteNumber => !siteNumbers.includes(siteNumber)) ?? [];

  if (siteNumbersWithoutMatch.length) {
    const orgs = await OrgService.fetchByQuery({
      criterion: {
        criteria: [
          {
            fieldCriterion: {
              field: 'PRACTICE_CODE',
              type: CriteriaType.IN,
              values: siteNumbersWithoutMatch,
            },
          },
        ],
      },
    });

    const sites = orgs.map(SiteMapper.from);
    return siteNumbersWithoutMatch.map(siteNumber => ({
      siteNumber,
      siteName: sites.find(site => site.siteNumber === siteNumber)?.name,
    }));
  } else {
    return [];
  }
};

export const BioSampleSiteQueryService = { findMismatchingSites };
